export default __webpack_public_path__ + "static/media/how-it-works-2.c11d1ac7.svg";